import { TwcProduct } from '../../../twc-products';

export const TURBULENCE_PRODUCT_DATA: TwcProduct = {
  id: 'turbulence',
  defaultProductId: 'globalGTG-FL240-boeing', // do not change
  productName: 'Weather-Turbulence-TWC',
  label: 'Turbulence',
  weatherType: 'TURBULENCE',
  description: 'TWC product (raster, forecast) - Turbulence Forecast',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 360,
  lodMax: 5,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 180,
  flightLevelProductIds: {
    FL110: 'globalGTG-FL110-boeing',
    FL130: 'globalGTG-FL130-boeing',
    FL150: 'globalGTG-FL150-boeing',
    FL180: 'globalGTG-FL180-boeing',
    FL210: 'globalGTG-FL210-boeing',
    FL240: 'globalGTG-FL240-boeing',
    FL270: 'globalGTG-FL270-boeing',
    FL300: 'globalGTG-FL300-boeing',
    FL340: 'globalGTG-FL340-boeing',
    FL390: 'globalGTG-FL390-boeing',
    FL430: 'globalGTG-FL430-boeing'
  },
  zOrder: 90
};
